// extracted by mini-css-extract-plugin
export default {"scale":"style_scale__JIJ0-","scale__item":"style_scale__item__IzyC8","fill":"style_fill__VcsBE"};